import { Component, OnInit } from '@angular/core';
import {AuthService} from '../auth.service';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public pass;
  constructor(private auth:AuthService, private router: Router, private toastr: ToastrManager) { }

  ngOnInit() {
          this.pass={
            oldPassword:"",
            newPassword:"",
            confirmPassword:"",
            poolId:localStorage.getItem("poolId"),
            clientId:localStorage.getItem("clientId")
            } 
  }
  changePassword(req){
    console.log(req)
    this.auth.changePassword(req).subscribe((data:any)=>{
       console.log(data)
      if(typeof data == 'string') {data = JSON.parse(data)}
      if(data.Status=='Success'){
        // window.alert('Password changed successfully')
       this.toastr.successToastr("Password Changed Successfully","Success!")
      }else{
        // window.alert('Password change Failed')
        this.toastr.errorToastr("Password Change Faailed","oops!")
      }
    })
  }
}
